import { render } from "./FormObat.vue?vue&type=template&id=5d4960b9"
import script from "./FormObat.vue?vue&type=script&lang=js"
export * from "./FormObat.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dev.pbf.infonetglobal.tech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__